import React from 'react';
import { Input } from 'antd';
import UsersList from "./UsersList";
import algoliasearch from 'algoliasearch';
import { AlgoliaSettings } from '../../constants/setting';

const { Search } = Input;


const client = algoliasearch(AlgoliaSettings.appId, AlgoliaSettings.apiKey);
const index = client.initIndex(AlgoliaSettings.indexUsers);

interface IState {
    showTravellers: boolean,
    ids : string[],
}

type IProps = unknown

class Users extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showTravellers: false,
            ids: [],
        }
    }

    search(value: string): void {
        index.search(value, {
            attributesToRetrieve: ['email', 'phoneNumber'],
            hitsPerPage: 10,
        }).then (({ hits }) => {
            if (value !== null && value !== "")
            {
                const ids :  string[] = []
                this.setState({ showTravellers: true });
                hits.forEach(hit => {
                    ids.push(hit.objectID);
                })
                this.setState({ ids: ids })
            }
        }
        );
    }

    render(): React.ReactNode {
        return (
            <div style={{
                margin: "16px"
            }}>
                <Search
                    placeholder="Search User's email or phone number"
                    onSearch={value => this.search(value)}
                    className="search"
                    style={{
                        marginBottom: "16px"
                    }}
                    size="large"
                />
                {this.state.showTravellers && <UsersList display={this.state.showTravellers} ids={this.state.ids}/>}
            </div>
        );
    }
}

export default Users;
